import { useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { productImageUrl } from "../utils/productImage";

function ThumbnailImage({ reference, src, size }) {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  return <Box data-product-thumbnail sx={{ width: size, height: size, flexShrink: 0,
    display: "grid", placeItems: "center", bgcolor: "#fff", border: "1px solid",
    borderColor: "divider", borderRadius: "10px", overflow: "hidden" }}>
    {!src || failed ? <Box role="img" aria-label={t("productThumbnail.unavailable")}
      sx={{ display: "flex", color: "#a49bc2" }}>
      <Inventory2OutlinedIcon sx={{ fontSize: 26 }} />
    </Box> : <Box component="img" src={src} alt={t("productThumbnail.image", { reference })}
      loading="lazy" decoding="async" referrerPolicy="no-referrer" onError={() => setFailed(true)}
      sx={{ width: "100%", height: "100%", objectFit: "contain", p: 0.5 }} />}
  </Box>;
}

/** Catalogue references define the image; failed images never prevent product selection. */
export function ProductThumbnail({ reference, size = { xs: 48, sm: 56 } }) {
  const src = productImageUrl(reference);
  return <ThumbnailImage key={src ?? "no-image"} reference={reference} src={src} size={size} />;
}
